// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fe2bf5ae","239":"eb8068a9","453":"634acb2a","732":"74b38fc2"}[chunkId] + ".chunk.js";
};